document.addEventListener("DOMContentLoaded", () => {
  const mainImage = document.querySelector(".soverlap-main-image");
  const overlapWrapper = document.querySelector(".so-overlap-wrapper");
  const sections = document.querySelectorAll(".so-wrapper");
  const innerWrapper = document.querySelector(".so-inner-wrapper");
  const videoTemplate = document.getElementById("so-video-template");
  const videoPlaceholder = document.getElementById("video-placeholder");

  let videoInjected = false;

  // --- Main image scroll effects ---
  const handleScroll = () => {
    const overlapWrapperRect = overlapWrapper.getBoundingClientRect();

    sections.forEach((section) => {
      const iconWithTextMain = section.querySelector(".so-reason-section");
      if (!iconWithTextMain) return;

      const rect = iconWithTextMain.getBoundingClientRect();

      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        mainImage.style.opacity = "0";
        mainImage.style.filter = "none";
        mainImage.style.transform = "none";
      } else if (overlapWrapperRect.top <= 0) {
        mainImage.style.opacity = "0.3";
        mainImage.style.filter = "blur(5px)";
        mainImage.style.transform = "scale(1.1)";
      } else {
        mainImage.style.opacity = "1";
        mainImage.style.filter = "none";
        mainImage.style.transform = "none";
      }
    });
  };

  window.addEventListener(
    "scroll",
    () => {
      requestAnimationFrame(handleScroll);
    },
    { passive: true }
  );

  handleScroll();

  // --- Video append logic ---
  if (innerWrapper && videoTemplate && videoPlaceholder && mainImage) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !videoInjected &&
            videoPlaceholder.children.length === 0
          ) {
            videoInjected = true;

            // Remove only the poster image inside innerWrapper with specific class
            const poster = innerWrapper.querySelector("img.video-poster");
            if (poster) poster.remove();

            // Append video template
            const clone = videoTemplate.content.cloneNode(true);
            videoPlaceholder.appendChild(clone);

            // Play on viewport
            const video = videoPlaceholder.querySelector(
              ".so-video-section__media"
            );
            if (video) {
              video.style.opacity = "0";
              video.style.transition = "opacity 0.4s ease";

              video.addEventListener("loadeddata", () => {
                video.style.opacity = "1";
              });

              const videoObs = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      video
                        .play()
                        .catch((e) => console.warn("Autoplay blocked:", e));
                    } else {
                      video.pause();
                    }
                  });
                },
                { threshold: 0.5 }
              );

              videoObs.observe(video);
            }

            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(mainImage); // 👈 Trigger when main image section comes into view
  }
});
